<template>
  <el-dialog
    :title="titleTrans"
    :visible.sync="centerDialogVisible"
    width="50%"
    @close="handleClose"
  >
    <div
      class="form-content"
      style="width:70%;padding-left:20px;"
    >
      <el-form
        ref="dataInfo"
        :model="dataInfo"
        :rules="rules"
        label-width="180px"
      >
        <el-form-item
          label="key值"
          prop="paramKey"
        >
          <span v-if="isEdit">{{ dataInfo.paramKey }}</span>
          <el-input
            v-else
            v-model="dataInfo.paramKey"
          />
        </el-form-item>
        <el-form-item
          label="value"
          prop="value"
        >
          <el-input v-model="dataInfo.value" />
        </el-form-item>
        <el-form-item
          label="备注"
          prop="remark"
        >
          <el-input
            v-model="dataInfo.remark"
            type="textarea"
          />
        </el-form-item>
        <el-form-item
          label="备用参数一"
          prop="param1"
        >
          <el-input v-model="dataInfo.param1" />
        </el-form-item>
        <el-form-item
          label="备用参数二"
          prop="param2"
        >
          <el-input v-model="dataInfo.param2" />
        </el-form-item>
        <el-form-item
          label="备用参数三"
          prop="param3"
        >
          <el-input v-model="dataInfo.param3" />
        </el-form-item>
      </el-form>
    </div>
    
    <span
      slot="footer"
      class="dialog-footer"
    >
     <el-button @click="handleClose">取消</el-button>
      <el-button
        type="primary"
        style="margin-left:8px"
        @click="submitForm('dataInfo')"
      >确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { paramDetail, addParam, validateParamKey } from '@/api/system'
export default {
  // props: ['editData'],
  props: {
    editData: {
      default: {}
    },
    isedit: {
      default: 'false'
    }
  },
  data() {
    return {
      isEdit: this.isedit,
      dataInfo: {
        id: '',
        paramKey: '',
        remark: '',
        param1: '',
        param2: '',
        param3: '',
        value: ''
      },
      centerDialogVisible: true,
      rules: {
        value: [
          { required: true, min: 1, max: 50, message: '请输入长度在 1到 50 个字符', trigger: 'blur' }
        ],
        paramKey: [{
          required: true,
          validator: this.checkoutCode,
          trigger: 'blur'
        }],
        remark: [
          { required: false, min: 0, max: 500, message: '最多不能超过500个字符', trigger: 'blur' }
        ],
        param1: [
          { required: false, min: 1, max: 50, message: '请输入长度在 1到 50 个字符', trigger: 'blur' }
        ],
        param2: [
          { required: false, min: 1, max: 50, message: '请输入长度在 1到 50 个字符', trigger: 'blur' }
        ],
        param3: [
          { required: false, min: 1, max: 50, message: '请输入长度在 1到 50 个字符', trigger: 'blur' }
        ]
      },
      data: null,
      submitData: {}
    }
  },
  computed: {
    titleTrans() {
      let result = '添加参数'
      if (this.isEdit) {
        result = '编辑参数'
      }
      return result
    }
  },
  mounted() {
    if (this.isEdit) {
      this.getParamDetail()
    }
  },
  methods: {
    getParamDetail() {
      paramDetail({ id: this.editData.id }).then(res => {
        if (res && res.code == 0) {
          this.dataInfo.paramKey = res.data.paramKey
          this.dataInfo.value = res.data.value
          this.dataInfo.remark = res.data.remark
          this.data = res.data
          var arr = []
          arr = res.data.spareParam.split(',')
          console.log(res.data)
          this.dataInfo.param1 = arr[0]
          this.dataInfo.param2 = arr[1]
          this.dataInfo.param3 = arr[2]
        }
      })
    },
    handleClose() {
      this.$emit('handleclose', null)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postData()
        } else {
          return false
        }
      })
    },
    checkoutCode(rule, value, callback) {
      const _data = {
        paramKey: this.dataInfo.paramKey
      }
      validateParamKey(_data).then(res => {
        if (res && res.code == 0) {
          if (value == '' || value == null || value == undefined) {
            callback('key值不能为空')
          } else if (value.length > 50) {
            callback(new Error('key值长度不能超过50'))
          } else if (res.data && !this.isEdit) {
            callback(new Error('key值不可以重复'))
          } else {
            callback()
          }
        }
      })
    },
    postData() {
      if (this.isEdit) {
        this.submitData.id = this.data.id
      }
      this.submitData.value = this.dataInfo.value
      this.submitData.paramKey = this.dataInfo.paramKey
      this.submitData.remark = this.dataInfo.remark
      if (this.dataInfo.param1) {
        this.submitData.spareParam = this.dataInfo.param1 + ',' + this.dataInfo.param2 + ',' + this.dataInfo.param3
      }

      addParam(this.submitData).then(res => {
        if (res && res.code == 0) {
          // 刷新父级列表(接口成功回调处理)
          this.$emit('refresh', null)
          this.$emit('handleclose', null)
        }
      })
    }
  }
}
</script>
